





















import { Component, Prop, Vue, Inject } from 'vue-property-decorator';
import { DxDataGrid, DxColumn, } from 'devextreme-vue/data-grid';
import { List } from 'linqts'
import moment from "moment";

// Servicios
import { logService } from '@/services/LogService';
import { eventService } from "@/services/EventService";
import { toastService } from '@/services/ToastService';
import { EstadisticasService } from '@/services/EstadisticasService';
import { Sorteo } from '@/model/Sorteo';

@Component({
  components: {
    DxDataGrid,
    DxColumn,
  },
})
export default class SorteoEstadisticaTotal extends Vue {

  estadisticasService: any | EstadisticasService = new EstadisticasService();
  sorteo: any | Sorteo = {};

  datasource: any = [];

  grid: any;
  columns: any = [
    {
      dataField: "Fecha",
      caption: "FECHA",
      sortOrder: "desc"
    },
    {
      dataField: "TotalDia",
      caption: "NÚMEROS VENDIDOS EN EL DIA"
    },
    {
      dataField: "TotalSorteo",
      caption: "NÚMEROS VENDIDOS EN TOTAL"
    }
  ];
  width: string = "100%";
  height: number = 500;
  headerFilter: any = { visible: true };

  onToolbarPreparing(e: any) {
    e.toolbarOptions.items.unshift(
    {
      location: "after",
      widget: "dxButton",
      options: {
        icon: "refresh",
        onClick: () => {
          this.load();
        }
      }
    });
  }

  mounted(){
    this.grid = (<any>this.$refs["gridEstadisticaTotal"]).instance;
    eventService.on("SorteoDetailLoaded", (res: Sorteo) =>{
      this.sorteo = res;
      this.load();
    });
  }

  load(){
    logService.Info("Inicio - Sorteo: "+this.sorteo.Id,"SorteoEstadisticaTotal.vue - load()");
    eventService.emit("LoadPanel", true);
    this.estadisticasService.CalcularEstadisticaTotal(this.sorteo.Id).then((res: any) => {
      this.datasource = res;
      eventService.emit("LoadPanel", false);
    })
  }
}
